/* tslint:disable */
require('./FieldUserRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_ef874ec6',
  user: 'user_ef874ec6',
  relative: 'relative_ef874ec6',
  main: 'main_ef874ec6',
  fabricIcon: 'fabricIcon_ef874ec6',
  actions: 'actions_ef874ec6',
  chat: 'chat_ef874ec6',
  sections: 'sections_ef874ec6',
  section: 'section_ef874ec6',
  header: 'header_ef874ec6',
  chevron: 'chevron_ef874ec6',
  contactItem: 'contactItem_ef874ec6',
  content: 'content_ef874ec6',
};

export default styles;
/* tslint:enable */